import { StyleSheet, TextStyle } from 'react-native';
import { FONT_STACK } from '@shared/styles';

export const UnvalidatedStyles = {
  sizeTiny: { fontSize: 10 },
  sizeSmall: { fontSize: 14 },
  sizeNormal: { fontSize: 16 },
  sizeLarge: { fontSize: 18 },
  sizeXLarge: { fontSize: 28 },
  numberOfLines(num: number): TextStyle {
    return {
      // Semi-hacky way to get a multiline numberOfLines cap.
      // TODO(fant): how well does this work across browsers?
      // https://css-tricks.com/line-clampin
      // TODO(fant): react-native-web will print errors
      // because it doesn't recognize these styles.
      // @ts-ignore
      display: '-webkit-box',
      WebkitLineClamp: num,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      whiteSpace: 'normal',
    };
  },
};

export const MBTextStyles = StyleSheet.create({
  sizeTiny: UnvalidatedStyles.sizeTiny,
  sizeSmall: UnvalidatedStyles.sizeSmall,
  sizeNormal: UnvalidatedStyles.sizeNormal,
  sizeLarge: UnvalidatedStyles.sizeLarge,
  sizeXLarge: UnvalidatedStyles.sizeXLarge,
  bold: { fontWeight: 'bold' },
  light: { fontWeight: '300' },
  italic: { fontStyle: 'italic' },
  center: { textAlign: 'center' },
  default: { fontFamily: FONT_STACK },
  underline: { textDecorationLine: 'underline' },
  formattedTextTouchable: {
    maxWidth: '100%',
    // prevent MBTouchableOpacity from filling width
    alignSelf: 'flex-end',
  },
  lineThrough: {
    textDecorationLine: 'line-through',
  } as any,
});
